

/// <amd-module name="Environments/ProviderCreateDetails/Kubernetes/Stores/AccessTokenStore" />
import { ActionsHubManager } from "Environments/Flux/ActionsHubManager";

import { StoreBase } from "Environments/Flux/Store";

import { AccessTokenActions, IAccessTokenPayload } from "../Actions/AccessTokenActions";

export class AccessTokenStore extends StoreBase {

    public static getKey(): string {
        return "k8s-res-access-token-store";
    }

    public initialize(instanceId: string): void {
        super.initialize(instanceId);

        this._actionsHub = ActionsHubManager.GetActionsHub<AccessTokenActions>(AccessTokenActions, instanceId);
        this._actionsHub.getAccessToken.addListener(this._addAccessToken);
    }

    protected disposeInternal(): void {
        this._actionsHub.getAccessToken.removeListener(this._addAccessToken);
    }

    private _addAccessToken = (payload: IAccessTokenPayload) => {
        this._state[payload.resourceTenantId] = payload.accessTokenKey;
    }

    public getState(): { [key: string]: string } {
        return this._state;
    }

    private _actionsHub: AccessTokenActions;
    private _state: { [key: string]: string } = {};
}